import React from 'react';

import { useCoinwebWallet } from '@/networks/coinweb';

import HeaderWalletDrawerCwebWalletConnect from './HeaderWalletDrawerCwebWalletConnect';
import HeaderWalletDrawerCwebWalletDetails from './HeaderWalletDrawerCwebWalletDetails';

interface HeaderWalletDrawerCwebWalletProps {}

const HeaderWalletDrawerCwebWallet: React.FC<HeaderWalletDrawerCwebWalletProps> = () => {
  const { isConnected } = useCoinwebWallet();

  if (isConnected) {
    return <HeaderWalletDrawerCwebWalletDetails />;
  }

  return <HeaderWalletDrawerCwebWalletConnect className="h-14 w-full rounded-xl text-base" />;
};

export default HeaderWalletDrawerCwebWallet;
